module.exports = __webpack_public_path__ + "img/ic-edit.7db0a785.svg";